module.exports = __webpack_public_path__ + "static/media/d790d565.jpg";